// Feature 08: Link Impact Correlation Badge Component

import { Chip, Tooltip } from '@mui/material';
import { TrendingUp, TrendingDown, TrendingFlat, Info } from '@mui/icons-material';
import { CorrelationLevel, LinkImpactBadgeProps } from '../../types/linkImpact.types';

const CORRELATION_CONFIG: Record<CorrelationLevel, {
  label: string;
  color: 'success' | 'info' | 'warning' | 'default';
  icon: React.ReactElement;
  description: string;
}> = {
  STRONG: {
    label: 'Strong Correlation',
    color: 'success',
    icon: <TrendingUp fontSize="small" />,
    description: 'Correlation coefficient > 0.7 - Strong evidence of relationship',
  },
  MODERATE: {
    label: 'Moderate Correlation',
    color: 'info',
    icon: <TrendingUp fontSize="small" />,
    description: 'Correlation coefficient 0.4-0.7 - Moderate evidence of relationship',
  },
  WEAK: {
    label: 'Weak Correlation',
    color: 'warning',
    icon: <TrendingFlat fontSize="small" />,
    description: 'Correlation coefficient 0.1-0.4 - Limited evidence of relationship',
  },
  NEGLIGIBLE: {
    label: 'Negligible Correlation',
    color: 'default',
    icon: <TrendingDown fontSize="small" />,
    description: 'Correlation coefficient < 0.1 - No meaningful relationship detected',
  },
};

const LinkImpactBadge: React.FC<LinkImpactBadgeProps> = ({
  level,
  score,
  showLabel = true,
  size = 'medium',
}) => {
  const config = CORRELATION_CONFIG[level];

  const chipLabel = showLabel
    ? `${config.label} (${score.toFixed(2)})`
    : score.toFixed(2);

  return (
    <Tooltip title={config.description} arrow>
      <Chip
        icon={config.icon}
        label={chipLabel}
        color={config.color}
        size={size}
        variant="outlined"
      />
    </Tooltip>
  );
};

export const CorrelationDisclaimer: React.FC = () => (
  <Chip
    icon={<Info fontSize="small" />}
    label="Supporting Signal"
    color="primary"
    variant="outlined"
    size="small"
  />
);

export default LinkImpactBadge;
